export default "__VITE_ASSET__BoCVdePl__"